module.exports = __webpack_public_path__ + "media/images/logo_white-99aa216921a6eb6acc5072e889c047eb.svg";